import { useCallback } from "react"

import { useNetworksStateContext, useSubNetworksWithWriteAccess } from "../contexts/NetworksContext"

export const useIsFeatureWritable = (module) => {
    const { selectedSubNetworkSlugs } = useNetworksStateContext()
    const subnetworksWithWriteAccess = useSubNetworksWithWriteAccess(selectedSubNetworkSlugs, module)

    const isWritable = useCallback((feature) => {
        const featureSubNetworkSlugs = feature.properties?.subNetworkSlugs || feature.sub_network_slugs
        if (!featureSubNetworkSlugs?.length) {
            return true
        }
        return subnetworksWithWriteAccess.some(subNetwork => featureSubNetworkSlugs.includes(subNetwork))
    }, [subnetworksWithWriteAccess])

    return isWritable
}